import { type Signal, signal } from "@preact/signals-react";

import type { MetroArea, Quantile } from "./watchlist.filters";

export class JobSalary {
  private subscribed = false;

  public readonly salary: Signal<number> = signal(NaN);

  public readonly salaryUp: Signal<boolean> = signal(false);

  public readonly salaryDown: Signal<boolean> = signal(false);

  public readonly netChange: Signal<number> = signal(NaN);

  public readonly netChangeUp: Signal<boolean> = signal(false);

  public readonly netChangeDown: Signal<boolean> = signal(false);

  public readonly totalCostProjectionOneYear: Signal<number> = signal(NaN);

  public readonly totalCostProjectionThreeYears: Signal<number> = signal(NaN);

  public readonly totalCostProjectionFiveYears: Signal<number> = signal(NaN);

  public readonly liquidity: Signal<number> = signal(0);

  public readonly averageTenureInYears: Signal<number> = signal(NaN);

  public readonly growthRate: Signal<number> = signal(NaN);

  public readonly growthRateUp: Signal<boolean> = signal(false);

  public readonly growthRateDown: Signal<boolean> = signal(false);

  public readonly netChangeOneYear: Signal<number> = signal(NaN);

  public readonly netChangeTwoYear: Signal<number> = signal(NaN);

  public readonly netChangeThreeYear: Signal<number> = signal(NaN);

  public readonly netChangeFourYear: Signal<number> = signal(NaN);

  public readonly netChangeFiveYear: Signal<number> = signal(NaN);

  public error: Error | null = null;

  constructor(
    public readonly streamName: string,
    public readonly id: string,
    public readonly title: string,
    public readonly titleAliases: string[],
    public readonly metroArea: MetroArea,
    public readonly quantile: Quantile,
    readonly initializeSubscription: ((jobSalary: JobSalary) => Promise<void>) | null,
  ) {
    if (!initializeSubscription) {
      this.subscribed = true;
    }
  }

  subscribe(): void {
    if (this.subscribed || !this.initializeSubscription) return;

    this.initializeSubscription(this).catch((err) => {
      this.error = err;
    });

    this.subscribed = true;
  }
}
